module.exports = __webpack_public_path__ + "media/images/active_material/icons/arrow-dropdown-375f58708f8f634c108525e0763cc70c.svg";